import { ITemplate } from '@/_types'
import { IEmployee } from '@/_types/employee'

export function getTemplateEmployee(template: ITemplate): IEmployee | null {
	return template.employee ?? template.workplace?.employee ?? null
}

export function filterTemplatesByEmployeeSlug(
	templates: ITemplate[],
	employeeSlug: string
): ITemplate[] {
	return templates.filter(template => getTemplateEmployee(template)?.slug === employeeSlug)
}
